export default "__VITE_ASSET__Csu8IgrQ__"